import { createTheme } from '@mui/material/styles';

export const mdgTheme = createTheme({
  palette: {
    primary: {
      main: '#06038d',
      light: '#f0f7fd',
      dark: '#06038d',
    },
    secondary: {
      main: '#06038d',
      light: '#f0f7fd',
    },
    background: {
      default: '#f0f7fd',
      paper: '#f0f7fd',
    },
    star: {
      empty: '#D1D5DB',
      filled: '#e6d130',
    },
    text: {
      primary: '#000000',
      secondary: '#06038d',
      disabled: 'grey',
    },
    warning: {
      main: '#ffff00',
    },
    action: {
      disabled: '#9e9e9e',
    },
    border: {
      primary: '#06038d',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '2.25rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#06038d',
      textAlign: 'center',
    },
    h2: {
      fontSize: '1.875rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#06038d',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700,
      marginBottom: '1rem',
      color: '#06038d',
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: '#03013b',
      textAlign: 'left',
      marginTop: '1em',
      marginBottom: '1em',
    },
    h6: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#000000',
    },
    caption: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#06038d',
      textAlign: 'left',
    },

    body1: {
      fontSize: '0.8rem',
      color: '#000000',
      arrowIconColor: '#FFFEF7', //for arrow in button
      priceQuoteBackground: '#f0f9ee',
      detailsTextColor: '#111928',
      descriptionTextColor: '#6b7280',
      ndrpSectionBackground: '#f9fafa',
      checkBoxBackground: '#f3f4f6',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#e4002b',
          borderRadius: '0.5rem',
          '&:hover': {
            backgroundColor: '#e4002b',
          },
          color: '#FFFFFF',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          color: 'rgb(107 114 128)',
          fill: '#43b02a',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          color: '#06038d',
          '&:hover': {
            color: '#06038d',
          },
          width: '1.5rem',
          height: '1.5rem',
          '&.Mui-disabled': {
            color: '#9e9e9e',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: 'rgb(17 24 39)',
          fontSize: '1rem',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
        },
      },
    },
  },
});
